const updates = [
  { date: '07-31', title: '《热辣盛夏》院线同步上线，4K杜比视界版本独家放送', tag: '新上线' },
  { date: '07-30', title: '国产悬疑剧《暗夜追踪》全集更新完毕，一口气刷完不费劲', tag: '完结' },
  { date: '07-29', title: '爆款综艺《笑声制造机》第六季开播，首期笑点密集', tag: '热播' },
  { date: '07-28', title: '日漫《星辰冒险谭》同步日本播出，双语字幕已更新至第8话', tag: '连载' },
  { date: '07-27', title: '豆瓣9.2高分纪录片《地球脉动III》中配版独家上线', tag: '高分' },
  { date: '07-26', title: '韩国悬疑电影《迷局》全网首播，反转结局引发热议', tag: '首播' },
  { date: '07-25', title: '《古装风华录》新剧开播，服化道精良引观众盛赞', tag: '新剧' },
  { date: '07-24', title: '科幻巨制《星际拓荒者》上线，视觉特效惊艳全平台', tag: '特效' },
  { date: '07-23', title: '年度最佳动画《画梦师》全系列上架，口碑持续走高', tag: '推荐' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            每日更新，好片不停，追剧党的一站式情报站
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 md:-translate-x-px"></div>

          <div className="space-y-6">
            {updates.map((item, i) => (
              <div
                key={i}
                className={`relative flex items-start gap-4 md:gap-8 ${
                  i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} pl-10 md:pl-0`}>
                  <div
                    className={`bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-colors ${
                      i % 2 === 0 ? 'md:mr-8' : 'md:ml-8'
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs text-foreground-500 font-medium">{item.date}</span>
                      <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed">
                      {item.title}
                    </h3>
                  </div>
                </div>

                <div className="absolute left-[9px] md:left-1/2 top-3 md:-translate-x-1/2 z-10">
                  <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
                </div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}